import { Button } from 'react-vant'
import { Success } from '@react-vant/icons'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function RefereeSuccess() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const code = searchParams.get('code')

    return (
        <div style={{
            padding: '40px 20px',
            background: 'var(--canvas-bg, #f8fafc)',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        }}>
            <div style={{
                background: '#ffffff',
                borderRadius: 20,
                padding: '40px 20px',
                boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                border: '1px solid #f1f5f9',
                textAlign: 'center'
            }}>
                <div style={{
                    width: 72, height: 72, borderRadius: 36,
                    background: '#e8f9f0',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 20px',
                    boxShadow: '0 6px 16px rgba(0, 181, 120, 0.2)'
                }}>
                    <Success fontSize={40} color="#00b578" />
                </div>

                <h2 style={{ color: '#0f172a', margin: '0 0 8px', fontSize: 22, fontWeight: 800 }}>成绩提交成功</h2>
                <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 32px' }}>本组运动员成绩已正式同步至云端实时赛况</p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <Button
                        block
                        round
                        onClick={() => navigate(`/sports/referee/login?code=${code}`, { replace: true })}
                        style={{
                            background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
                            border: 'none',
                            color: '#ffffff',
                            fontWeight: 700,
                            height: 44,
                            boxShadow: '0 4px 14px rgba(5, 107, 79, 0.3)'
                        }}
                    >
                        返回组次任务列表
                    </Button>
                    <Button
                        block
                        round
                        onClick={() => navigate('/sports/referee/login', { replace: true })}
                        style={{
                            background: '#f8fafc',
                            borderColor: '#e2e8f0',
                            color: '#475569',
                            fontWeight: 600,
                            height: 44
                        }}
                    >
                        切换项目口令
                    </Button>
                </div>
            </div>
        </div>
    )
}
